import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./SportSelect.css";
import { useNavigate } from "react-router-dom";


export default function SportSelect() {
  const [sport, setSport] = useState("");
  const [accepted, setAccepted] = useState(true);
  const [loading, setLoading] = useState(false);
  const [teamCategory, setTeamCategory] = useState("");
  const [teamType, setTeamType] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const navigate = useNavigate();

  // useEffect(() => {
  //   const checkUser = async () => {
  //     const userId = localStorage.getItem("userId");
  //     const selectedSport = localStorage.getItem("sport");
  //     const selectedTeamType = localStorage.getItem("teamType");

  //     if (userId && selectedSport && selectedTeamType) {
  //       try {
  //         const res = await fetch(`https://node.aattumtpl.com/api/auth/validate/${userId}`);
  //         const data = await res.json();
  //         if (res.ok && data.exists) {
  //           handleNavigation(selectedSport, selectedTeamType, userId);
  //         } else {
  //           localStorage.clear();
  //         }
  //       } catch (err) {
  //         console.error("Error validating user:", err);
  //         localStorage.clear();
  //       }
  //     }
  //   };
  //   checkUser();
  // }, [navigate]);

  

  // const handleNavigation = (sport, teamType, userId) => {
  //   const sportLower = sport.toLowerCase();
  //   const typeLower = teamType.toLowerCase();

  //   if (sportLower === "cricket") {
  //     navigate("/cricket-homepage");
  //   } else if (["football", "kabaddi", "hockey", "basketball", "volleyball"].includes(sportLower)) {
  //     const path = `/${sportLower}${typeLower === "team" ? "-form" : "-individual-form"}/${userId}`;
  //     navigate(path);
  //   } else {
  //     navigate("/", { replace: true });
  //   }
  // };

  // const handleProceed = async () => {
  //   if (!sport) return alert("Please select a sport!");
  //   if (!teamCategory) return alert("Please select a gender category!");
  //   if (!teamType) return alert("Please select Individual or Team!");

  //   try {
  //     setLoading(true);
  //     const res = await fetch("https://node.aattumtpl.com/api/auth/create", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         sport,
  //         genderCategory: teamCategory,
  //         teamType,
  //         termsAccepted: accepted,
  //       }),
  //     });

  //     const text = await res.text();
  //     let data;
  //     try {
  //       data = JSON.parse(text);
  //     } catch (err) {
  //       console.error("Invalid response:", text);
  //       return alert("Server returned invalid response.");
  //     }

  //     if (res.ok && data.success) {
  //       const userId = data.userId;
  //       localStorage.setItem("userId", userId);
  //       localStorage.setItem("sport", sport);
  //       localStorage.setItem("teamType", teamType);
  //       handleNavigation(sport, teamType, userId);
  //       window.scrollTo(0, 0);
  //     } else {
  //       alert(data.error || "Something went wrong.");
  //     }
  //   } catch (err) {
  //     console.error("Error:", err);
  //     alert("Server error. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //     setShowPopup(false);
  //   }
  // };
const groups = {
  "Group A": ["AJVJ", "SK Salem", "Queens"],
  "Group B": ["Risor", "SK SRMC", "Fearless"],
  "Group C": ["Uttarakhand", "Guru Nanak", "SK Drome"],
  "Group D": ["Signature", "Kairaa", "Believe"],
};

const schedule = [
  { date: "Dec 14, 2025", t1: "AJVJ vs SK Salem", t2: "AJVJ vs Queens", t3: "Queens vs SK Salem" },
  { date: "Dec 15, 2025", t1: "Signature vs Kairaa", t2: "Signature vs Believe", t3: "Kairaa vs Believe" },
  { date: "Dec 16, 2025", t1: "Risor vs SK SRMC", t2: "SK SRMC vs Fearless", t3: "Fearless vs Risor" },
  { date: "Dec 17, 2025", t1: "Uttarakhand vs Guru Nanak", t2: "Guru Nanak vs SK Drome", t3: "SK Drome vs Uttarakhand" },
  { date: "Dec 18, 2025", t1: "QF A1 vs D2", t2: "-", t3: "QF D1 vs A2" },
  { date: "Dec 19, 2025", t1: "QF B1 vs C2", t2: "-", t3: "QF B2 vs C1" },
  { date: "Dec 20, 2025", t1: "SF 1 Winner QF1 vs QF4", t2: "-", t3: "SF 2 Winner QF2 vs QF3" },
  { date: "Dec 21, 2025", t1: "Third Place", t2: "-", t3: "Final" },
];

  const sports = [
    {
      name: "Cricket",
      image: "/Images/1.png",
     
    },
    {
      name: "Football",
      image: "/Images/2.png",
      
    },
    {
      name: "Kabaddi",
      image: "/Images/4.png",
      
    },
    {
      name: "Hockey",
      image: "/Images/5.png",
      
    },
    {
      name: "Basketball",
      image: "/Images/3.png",
    
    },
    {
      name: "Volleyball",
      image: "/Images/6.png",
     
    },
  ];

  return (
    <div className="sportselect-outer">
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="sportselect-page"
      >
        <h2 className="sportselect-heading">
          <span>AATTUM TPL</span> SPORTS CATEGORY
        </h2>
        <p className="sportselect-subheading">
          Choose your sport and start your journey!
        </p>

        <div className="sports-grid">
  {sports.map((item, i) => (
    <motion.div
      key={i}
      className="sport-card"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: i * 0.15 }}
      whileHover={{ scale: 1.05 }}
    >
      <img src={item.image} className="sport-img" alt={item.name} />
      
      <div className="sport-overlay">
        {item.name === "Cricket" ? (
         <button
  className="sport-btn"
  onClick={() => {
    navigate("/cricket-homepage");
    window.scrollTo(0, 0);
  }}
>
  <span>Select</span>
</button>

        ) : (
          <button className="sport-btn disabled-btn" disabled>
            <span>Coming Soon</span>
          </button>
        )}
      </div>
    </motion.div>
  ))}
</div>


        {/* <div className="sports-grid">
          {sports.map((item, i) => (
            <motion.div
              key={i}
              className="sport-card"
              onClick={() => {
                setSport(item.name);
                setShowPopup(true);
              }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              whileHover={{ scale: 1.05 }}
            >
               <img src={item.image} className="sport-img" />
     <div className="sport-overlay">

  {item.name === "Cricket" ? (
    <button className="sport-btn">
      <span><span>Select</span></span>
    </button>
  ) : (
    <button className="sport-btn disabled-btn" disabled>
      <span><span>Coming Soon</span></span>
    </button>
  )}

</div>


            </motion.div>
          ))}
        </div> */}
      </motion.div>

{/*      
      <AnimatePresence>
        {showPopup && (
       <motion.div
  className="popup-overlay"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
>
  <motion.div
    className="popup-container"
    initial={{ scale: 0.8, opacity: 0, y: 50 }}   
    animate={{ scale: 0.9, opacity: 1, y: 0 }}   
    exit={{ scale: 0.7, opacity: 0, y: 50 }}     
    transition={{ type: "spring", damping: 15 }}
  >
              <h3>{sport} Registration</h3>

              <div className="popup-row">
                <label>Gender Category:</label>
                <select value={teamCategory} onChange={(e) => setTeamCategory(e.target.value)}>
                  <option value="">Select</option>
                  <option value="Men">Men</option>
                  <option value="Women">Women</option>
                </select>
              </div>

              <div className="popup-row">
                <label>Participation Type:</label>
                <select value={teamType} onChange={(e) => setTeamType(e.target.value)}>
                  <option value="">Select</option>
                  <option value="Individual">Individual</option>
                  <option value="Team">Team</option>
                </select>
              </div>

              <div className="popup-buttons">
                <button onClick={() => setShowPopup(false)} className="cancel-btn">
                  Cancel
                </button>
                <button onClick={handleProceed} disabled={loading} className="proceed-btn">
                  {loading ? "Processing..." : "Proceed"}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}

 {/* <div className="fixtures-wrap">

  
      <motion.h2 initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        FIXTURES
      </motion.h2>

      <div className="group-grid">
        {Object.entries(groups).map(([group, teams], i) => (
          <motion.div
            key={group}
            className="group-card"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.15 }}
          >
            <h3>{group}</h3>
            <ul>
              {teams.map((team) => (
                <li key={team}>{team}</li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>


      <motion.h2
        className="schedule-title"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
      >
        MATCH SCHEDULE
      </motion.h2>

      <div className="schedule-table">
        <div className="schedule-header">
          <span>Date</span>
          <span>8 AM</span>
          <span>11 AM</span>
          <span>2 PM</span>
        </div>

        {schedule.map((row, i) => (
          <motion.div
            className="schedule-row"
            key={i}
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.08 }}
          >
            <span className="date-pill">{row.date}</span>
            <span>{row.t1}</span>
            <span>{row.t2}</span>
            <span>{row.t3}</span>
          </motion.div>
        ))}
      </div>

    </div> */}
    </div>
  );
}












































// import React, { useState, useEffect } from "react";
// import "./SportSelect.css";
// import { useNavigate } from "react-router-dom";

// export default function SportSelect() {
//   const [sport, setSport] = useState("");
//   const [accepted, setAccepted] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [teamCategory, setTeamCategory] = useState("");
//   const [teamType, setTeamType] = useState("");
//   const navigate = useNavigate();

//   // 🔹 Run once when page loads
//   useEffect(() => {
//     const checkUser = async () => {
//       const userId = localStorage.getItem("userId");
//       const selectedSport = localStorage.getItem("sport");
//       const selectedTeamType = localStorage.getItem("teamType");

//       if (userId && selectedSport && selectedTeamType) {
//         try {
//           const res = await fetch(`https://node.aattumtpl.com/api/auth/validate/${userId}`);
//           const data = await res.json();

//           if (res.ok && data.exists) {
//             // ✅ User exists → navigate properly
//             handleNavigation(selectedSport, selectedTeamType, userId);
//           } else {
//             // ❌ Invalid user → clear storage
//             localStorage.clear();
//           }
//         } catch (err) {
//           console.error("Error validating user:", err);
//           localStorage.clear();
//         }
//       }
//     };

//     checkUser();
//   }, [navigate]);

//   // 🔹 Common Navigation Function
//   const handleNavigation = (sport, teamType, userId) => {
//     if (sport === "Cricket" && teamType === "Team") {
//       navigate(`/cricket-form/${userId}`);
//     } else if (sport === "Cricket" && teamType === "Individual") {
//       navigate(`/cricket-individual-form/${userId}`);
//     } else if (sport === "Football" && teamType === "Team") {
//       navigate(`/football-form/${userId}`);
//     } else if (sport === "Football" && teamType === "Individual") {
//       navigate(`/football-individual-form/${userId}`);
//     } else if (sport === "Kabaddi" && teamType === "Team") {
//       navigate(`/kabaddi-form/${userId}`);
//     } else if (sport === "Kabaddi" && teamType === "Individual") {
//       navigate(`/kabaddi-individual-form/${userId}`);
//     } else if (sport === "Hockey" && teamType === "Team") {
//       navigate(`/hockey-form/${userId}`);
//     } else if (sport === "Hockey" && teamType === "Individual") {
//       navigate(`/hockey-individual-form/${userId}`);
//     } else if (sport === "Basketball" && teamType === "Team") {
//       navigate(`/basketball-form/${userId}`);
//     } else if (sport === "Basketball" && teamType === "Individual") {
//       navigate(`/basketball-individual-form/${userId}`);
//     } else if (sport === "Volleyball" && teamType === "Team") {
//       navigate(`/volleyball-form/${ userId }`); {/* ✅ Added */ }
//     } else if (sport === "Volleyball" && teamType === "Individual") {
//       navigate(`/volleyball-individual-form/${ userId }`); {/* ✅ Added */ }
//     } else {
//       navigate("/", { replace: true });
//     }
//   };
  

// // 🔹 On Proceed
// const handleProceed = async () => {
//   if (!sport) return alert("Please select a sport!");
//   if (!accepted) return alert("Please accept the Terms & Conditions to proceed.");
//   if (!teamCategory) return alert("Please select a gender category!");
//   if (!teamType) return alert("Please select Individual or Team!");

//   try {
//     setLoading(true);

//     const res = await fetch("https://node.aattumtpl.com/api/auth/create", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         sport,
//         genderCategory: teamCategory, // Men/Women
//         teamType,                     // Individual/Team
//         termsAccepted: accepted,
//       }),
//     });

//     // Read response as text first
//     const text = await res.text();

//     let data;
//     try {
//       data = JSON.parse(text); // Try parsing JSON
//     } catch (err) {
//       console.error("Server returned invalid JSON:", text);
//       return alert("Server returned invalid response. Please try again later.");
//     }

//     if (res.ok && data.success) {
//       const userId = data.userId;

//       // Save user info in localStorage
//       localStorage.setItem("userId", userId);
//       localStorage.setItem("sport", sport);
//       localStorage.setItem("teamType", teamType);

//       // ✅ Navigate using common function
//       handleNavigation(sport, teamType, userId);

//       window.scrollTo(0, 0);
//     } else {
//       alert(data.error || "Something went wrong. Try again.");
//     }
//   } catch (err) {
//     console.error("Error submitting registration:", err);
//     alert("Server error. Please try again later.");
//   } finally {
//     setLoading(false);
//   }
// };


//   return (
//     <div className="sportselect-outer">
//       <div className="sportselect-page">
//         {/* Header Banner */}
//         <div className="sportselect-header">
//           <img
//             src="https://thumbs.dreamstime.com/b/group-diverse-athletes-silhouette-playing-various-sports-colorful-paint-splatter-effect-behind-them-346251913.jpg"
//             alt="Sports Banner"
//             className="sportselect-banner"
//           />
//         </div>
//         <div className="sportselect-top">
//           <h2 className="sportselect-heading">SPORTS REGISTRATION PORTAL</h2>

//           <p className="sportselect-subheading">Register your team today to confirm entry and secure a spot in the exciting upcoming tournament.</p>

//           {/* Dropdown inline with label */}
//           <div className="sportselect">

//             <div className="sportselect-row">
//               <label className="sportselect-label">Preferred Sport :</label>
//               <select
//                 value={sport}
//                 onChange={(e) => setSport(e.target.value)}
//                 className="sportselect-dropdown23"
//               >
//                 <option value="">-- Select --</option>
//                 <option value="Cricket">Cricket</option>
//                 <option value="Football">Football</option> {/* ⚽ Added Football */}
//                 <option value="Kabaddi">Kabaddi</option>
//                 <option value="Hockey">Hockey</option>
//                 <option value="Basketball">Basketball</option>
//                 <option value="Volleyball">Volleyball</option>
//               </select>
//             </div>

//             <div className="sportselect-row">
//               <label className="sportselect-label">Gender Category :</label>
//               <select
//                 value={teamCategory}
//                 onChange={(e) => setTeamCategory(e.target.value)}
//                 className="sportselect-dropdown"
//               >
//                 <option value="">-- Select --</option>
//                 <option value="Men">Men</option>
//                 <option value="Women">Women</option>
//               </select>
//             </div>
//           </div>

//           <div className="sportselect-row23">
//             <label className="sportselect-label">Participation Type :</label>
//             <select
//               value={teamType}
//               onChange={(e) => setTeamType(e.target.value)}
//               className="sportselect-dropdown"
//             >
//               <option value="">-- Select --</option>
//               <option value="Individual">Individual</option>
//               <option value="Team">Team</option>
//             </select>
//           </div>


//           {/* Agreement section */}
//           <div className="sportselect-agreement">
//             <h3>Terms & Conditions</h3>
//             <ul>
//               <li>All players must arrive at least 15 minutes before the match starts.</li>
//               <li>Proper sports attire is mandatory during the tournament.</li>
//               <li>Decisions made by referees/officials are final and must be respected.</li>
//               <li>Any misconduct, abusive language, or unfair play may result in disqualification.</li>
//               <li>The organizers are not responsible for personal injuries or loss of belongings.</li>
//               <li>By registering, you confirm that you are physically fit to participate.</li>
//             </ul>

//             <p>
//               The tournament committee reserves the right to modify the schedule or
//               format of matches in case of unforeseen circumstances, such as weather
//               conditions or venue availability. Players are expected to stay updated
//               through official communication channels.
//             </p>
//             <p>
//               All participants are expected to uphold the spirit of sportsmanship and
//               camaraderie throughout the event. Any disputes or grievances should be
//               reported directly to the organizing committee, whose decision will be
//               considered final and binding.
//             </p>

//             <p>
//               By joining this event, you acknowledge that participation is entirely
//               voluntary and at your own risk. You also grant permission to the
//               organizers to use photos or videos captured during the event for
//               promotional purposes without any compensation.
//             </p>

//             <div className="sportselect-agreecheck">
//               <input
//                 type="checkbox"
//                 id="terms"
//                 checked={accepted}
//                 onChange={(e) => setAccepted(e.target.checked)}
//               />
//               <label htmlFor="terms" >
//                 I have read and accept the Terms & Conditions
//               </label>
//             </div>
//           </div>

//           {/* Proceed Button */}

//           <div className="sportselect-btn-container">
//             <button
//               className="sportselect-button"
//               onClick={handleProceed}
//               disabled={loading}
//             >
//               {loading ? "Processing..." : "Proceed"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
